export default "__VITE_ASSET__B6NI94E___"